import { Link } from 'react-router-dom';
import { categories } from '@/mocks/asmrData';

const featuredData = [
  {
    slug: 'ultimate-trigger-guide',
    title: '2026年度最佳ASMR触发音合集推荐',
    category: 'trigger-sounds',
    excerpt: '从经典敲击到创新耳语，我们精选了今年最受欢迎的50个ASMR触发音作品，每一个都经过专业录制和精心后期处理。带你探索ASMR触发音的无限可能。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20soft%20minimalist%20scene%20with%20warm%20cream%20and%20beige%20tones%2C%20delicate%20textures%20evoking%20ASMR%20sound%20sensations%20like%20tapping%20and%20whispering%2C%20gentle%20abstract%20compositions%20with%20floating%20elements%2C%20dreamy%20atmosphere%2C%20calming%20aesthetic%2C%20fine%20art%20photography%20style%2C%20soft%20focus%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=featured-01&orientation=landscape',
    date: '2026-07-28',
    readTime: '8',
  },
  {
    slug: 'deep-sleep-asmr',
    title: '睡不着？试试这10个专业助眠ASMR音频',
    category: 'sleep-aid',
    excerpt: '失眠困扰着越来越多的人。我们邀请了专业ASMR艺术家，为你打造了一套科学的助眠音频方案。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20serene%20nighttime%20scene%20with%20soft%20moonlight%20and%20gentle%20stars%2C%20warm%20cream%20and%20lavender%20tones%2C%20dreamy%20abstract%20clouds%2C%20peaceful%20and%20calming%20atmosphere%20for%20sleep%2C%20minimalist%20aesthetic%2C%20fine%20art%20photography%20style%2C%20soft%20focus%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=featured-02&orientation=landscape',
    date: '2026-07-25',
    readTime: '6',
  },
  {
    slug: 'meditation-beginners',
    title: 'ASMR冥想入门：从零开始的减压之旅',
    category: 'stress-relief',
    excerpt: '冥想不必复杂。用ASMR的方式开始你的冥想练习，让声音引导你进入深度放松状态。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20meditation%20space%20with%20warm%20amber%20light%2C%20soft%20flowing%20fabric%20textures%2C%20gentle%20steam%20and%20incense%20smoke%2C%20peaceful%20zen%20atmosphere%2C%20cream%20and%20beige%20tones%2C%20calming%20aesthetic%2C%20fine%20art%20photography%20style%2C%20soft%20focus%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=featured-03&orientation=landscape',
    date: '2026-07-22',
    readTime: '10',
  },
];

export default function FeaturedSection() {
  const getCategoryName = (slug: string) => categories.find((c) => c.slug === slug)?.name || '';

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              精选推荐内容
            </h2>
            <p className="text-foreground-600 leading-relaxed">
              编辑团队精心挑选的优质ASMR内容，不容错过
            </p>
          </div>
          <Link
            to="/category/trigger-sounds"
            className="inline-flex items-center gap-1.5 text-sm text-accent-600 font-medium hover:text-accent-700 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredData.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-2xl overflow-hidden hover:bg-background-100/80 transition-all duration-300"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                  {getCategoryName(article.category)}
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-calendar-line"></i> {article.date}</span>
                  <span className="flex items-center gap-1"><i className="ri-time-line"></i> {article.readTime} 分钟阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}